export const isValidHouseholdIncome = (householdIncome, grossAnnualIncome) => {
  return parseInt(householdIncome) >= parseInt(grossAnnualIncome);
};
